import { cn } from "lib/utils";
import React from "react";

import confirmCheck from "assets/images/totem/confirm-check.svg";
import { TotemScheduling } from "store/ducks/totem-scheduling";
import { ActionButton } from "../ActionButton";
import { SchedulingDetailsCard } from "../SchedulingDetailsCard";
import { Stepper } from "../Stepper";
import { TotemHeader } from "../TotemHeader";

type Props = {
	scheduling: TotemScheduling;
	onConfirm: () => void;
	onBack: () => void;
	loading?: boolean;
};

export const ConfirmArrivalScreen: React.FC<Props> = ({
	scheduling,
	onConfirm,
	onBack,
	loading = false,
}) => (
	<main
		className={cn(
			"mx-auto flex min-h-full w-full max-w-[800px] flex-col items-center gap-14 bg-white px-6 pb-14 pt-8 max-[1023px]:px-5 max-[1023px]:pb-10 max-[1023px]:pt-6 max-[639px]:gap-8 max-[639px]:px-3 max-[639px]:pb-8 max-[639px]:pt-4",
		)}
	>
		<section className={cn("relative w-full shrink-0")}>
			<div
				className={cn(
					"relative mt-14 flex min-h-[1060px] w-full flex-col items-start gap-[10px] bg-[#F3F4F6] px-14 pb-14 pt-24 max-[1023px]:mt-12 max-[1023px]:px-8 max-[1023px]:pb-10 max-[1023px]:pt-20 max-[639px]:mt-10 max-[639px]:min-h-[740px] max-[639px]:px-4 max-[639px]:pb-6 max-[639px]:pt-20",
				)}
			>
				<Stepper currentStep={3} />
				<div
					className={cn(
						"flex w-full flex-col items-start gap-[10px] pb-6",
					)}
				>
					<h1
						className={cn(
							"w-full font-sans text-[32px] font-bold leading-normal text-[#1D293D] max-[639px]:text-[18px]",
						)}
					>
						Confirme sua chegada
					</h1>
					<p
						className={cn(
							"w-full font-sans text-[24px] leading-normal text-[#45556C] max-[639px]:text-[14px]",
						)}
					>
						Confira os dados antes de finalizar.
					</p>
				</div>
				<SchedulingDetailsCard scheduling={scheduling} />
			</div>
			<TotemHeader />
		</section>
		<ActionButton
			iconSrc={confirmCheck}
			onClick={onConfirm}
			loading={loading}
			loadingText="Registrando..."
		>
			Confirmar check-in
		</ActionButton>
		<ActionButton variant="secondary" direction="back" onClick={onBack}>
			Voltar
		</ActionButton>
	</main>
);
